export default __webpack_public_path__ + "static/media/Beanbag.63064d51.svg";